var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _tspan, _tspan2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimActivationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 449 496",
    width: 449,
    height: 496,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "tspan{white-space:pre}.a{fill:none}.b{font-size: 5px;fill: #000000;font-family: \"' Helvetica  Neue'\"}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m161.7 339.1v-12.7l-19.3-0.5-33.2 28v30.6h52.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m338.3 211v242.9c0 7.1-5.8 13-13 13l-268.2 0.1c-7.1 0-13-5.8-13-13v-396.2c0-7.1 5.8-13 13-13h218.7l23 26.7c-16.3 14.9-26.8 36.1-26.8 59.9 0 39.7 28.7 72.6 66.3 79.6zm-52.8 19.7c0-14.3-11.7-26-26-26h-136.6c-14.3 0-26 11.7-26 26v179.5c0 14.3 11.7 26 26 26h136.6c14.4 0 26-11.7 26-26z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m218 326.4v12.6 84.7h41.5c7.5 0 13.6-6.1 13.6-13.6v-56.3l-33.2-28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m422 131.4c0 37.9-30.9 68.8-68.8 68.8-37.9 0-68.8-30.9-68.8-68.8 0-37.9 30.9-68.8 68.8-68.8 37.9 0 68.8 30.9 68.8 68.8zm-35.4-36.3c-2.8-2-6.6-1.4-8.6 1.4l-40.4 55.5-9.3-13.4c-2-2.8-5.8-3.5-8.6-1.5-2.8 2-3.4 5.8-1.5 8.6l14.3 20.5c1.1 1.6 3 2.6 5 2.6 0.1 0 0.1 0 0.1 0 2 0 3.8-0.9 5-2.5l45.5-62.5c2-2.8 1.4-6.6-1.5-8.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m161.7 396.8h-52.5v13.4c0 7.5 6.1 13.6 13.6 13.6h38.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m273.1 302.2l-21.3 17.6 21.3 18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m205.7 252.1v-35.1h-31.6v70.2h31.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m218 245.9h55.1v-15.3c0-7.5-6.1-13.6-13.6-13.6h-41.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m161.7 314.1v-20.7-76.4h-38.9c-7.5 0-13.6 6.1-13.6 13.6v55.7l33.3 27.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m174.1 345.3h31.6v78.6h-31.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m273.1 258.3h-55.1v35.1c0 3.4-2.8 6.2-6.2 6.2h-37.8v33.4h31.6v-12.5c0-3.4 2.7-6.1 6-6.2l28.2-0.7 33.3-27.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m109.2 302.2v35.6l21.4-18z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m285.5 410.1c0 14.3-11.7 26-26 26h-136.6c-14.3 0-26-11.7-26-26v-179.5c0-14.3 11.7-26 26-26h136.6c14.4 0 26 11.7 26 26zm-45.6-96.5l33.3-27.3v-28h-55.1v35.1c0 3.4-2.8 6.2-6.2 6.2h-37.8v33.4h31.6v-12.5c0-3.4 2.6-6.1 6-6.2zm-130.7 24.1l21.4-18-21.4-17.5zm0 46.8h52.5v-58.1l-19.3-0.5-33.2 28zm64.9-97.3h31.6v-70.2h-31.6zm0 58.1v78.6h31.6v-78.6zm77.6-25.6l21.4 18v-35.5zm7.8-102.7h-41.5v28.9h55.1v-15.3c0-7.5-6.1-13.6-13.6-13.6zm-150.3 69.3l33.3 27.3 19.2 0.5v-97.1h-38.9c-7.5 0-13.6 6.1-13.6 13.6zm13.6 137.5h38.9v-27h-52.5v13.4c0 7.5 6.1 13.6 13.6 13.6zm150.4-13.6v-56.2l-33.2-28-22 0.5v97.3h41.5c7.5 0 13.6-6.1 13.6-13.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m434.4 131.4c0 44.8-36.5 81.2-81.2 81.2-0.9 0-1.7-0.3-2.5-0.3v241.7c0 14-11.4 25.4-25.4 25.4l-268.2 0.1c-14 0-25.4-11.4-25.4-25.4v-396.2c0-14 11.4-25.4 25.4-25.4h221.6c1.8 0 3.5 0.7 4.7 2.1l25.1 29.1c12.8-8.5 28.2-13.5 44.7-13.5 44.7 0 81.2 36.4 81.2 81.2zm-96 322.6v-242.8c-37.6-7-66.3-40-66.3-79.7 0-23.8 10.4-45 26.8-59.9l-23-26.7h-218.8c-7.1 0-13 5.8-13 13v396.2c0 7.2 5.8 13 13 13l268.2-0.1c7.1 0 13-5.8 13-13zm83.6-322.6c0-38-30.9-68.8-68.8-68.8-37.9 0-68.8 30.9-68.8 68.8 0 37.9 30.9 68.8 68.8 68.8 37.9 0 68.8-30.8 68.8-68.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m378.1 96.5l-40.4 55.5-9.3-13.4c-1.9-2.8-5.8-3.5-8.6-1.5-2.8 1.9-3.5 5.8-1.5 8.6l14.3 20.5c1.1 1.6 3 2.6 5 2.6 0 0 0 0 0.1 0 2 0 3.8-0.9 5-2.5l45.5-62.5c2-2.7 1.4-6.6-1.4-8.6-2.9-2.1-6.7-1.4-8.7 1.3z"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      transform: "matrix(1,0,0,1,-23,527)"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "b"
  }, "Created by Econceptive\r\n"))), /*#__PURE__*/React.createElement("text", {
    style: {
      transform: "matrix(1,0,0,1,-23,532)"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "b"
  }, "from the Noun Project\r\n"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimActivationIcon);
export default __webpack_public_path__ + "static/media/SimActivationIcon.d15b15724b5eccdf9118bdce3fae2058.svg";
export { ForwardRef as ReactComponent };